import { useRef } from 'react';

export const useHoverSound = (soundPath: string, volume: number = 0.03, delay: number = 170) => {
    const hoverSound = useRef<HTMLAudioElement | null>(null);
    const hoverTimeout = useRef<NodeJS.Timeout | null>(null);

    const handleMouseEnter = () => {
        if (!hoverSound.current) {
            hoverSound.current = new Audio(soundPath);
            hoverSound.current.volume = volume;
        }
        
        hoverTimeout.current = setTimeout(() => {
            hoverSound.current?.play().catch(e => console.log('Audio play failed:', e));
        }, delay);
    };

    const handleMouseLeave = () => {
        if (hoverTimeout.current) {
            clearTimeout(hoverTimeout.current);
        }
    };

    return {
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave
    };
};
